import { ReactNode } from 'react';
import ClientHeader from './ClientHeader';
import ClientTopNav from './ClientTopNav';
import ClientBottomNav from './ClientBottomNav';
import ClientFooter from './ClientFooter';
import OrderConfirmationBanner from './OrderConfirmationBanner';

interface ClientLayoutProps {
  children: ReactNode;
}

function ClientLayout({ children }: ClientLayoutProps) {
  return (
    <div className="client-app">
      <div className="client-header-fixed">
        <ClientHeader />
        <ClientTopNav />
      </div>
      <main className="mobile-content">
        {children}
      </main>
      <ClientFooter />
      <ClientBottomNav />
      <OrderConfirmationBanner />
    </div>
  );
}

export default ClientLayout;

